import { localTimezone } from '@/shared/lib/format';

export function Footer() {
  return (
    <footer className="flex items-center justify-between gap-4 border-t border-border px-6 py-3">
      <span className="text-[11px] text-faint">
        iFlow · API Analyzer · times in {localTimezone()}
      </span>
    </footer>
  );
}
